__turbopack_context__.v({
  "button": "CTA-module-scss-module__RoghLG__button",
  "compliment": "CTA-module-scss-module__RoghLG__compliment",
  "heading": "CTA-module-scss-module__RoghLG__heading",
  "inner": "CTA-module-scss-module__RoghLG__inner",
  "label": "CTA-module-scss-module__RoghLG__label",
  "links": "CTA-module-scss-module__RoghLG__links",
  "root": "CTA-module-scss-module__RoghLG__root",
  "visitUs": "CTA-module-scss-module__RoghLG__visitUs",
});
